import { createSlice } from '@reduxjs/toolkit';
import { getTeams } from '../../services/teams/getTeams';
import { createTeam as createTeamApi } from '../../services/teams/createTeam';
import { updateTeam as updateTeamApi } from '../../services/teams/updateTeam';
import { deleteTeam as deleteTeamApi } from '../../services/teams/deleteTeam';

const initialState = {
  isLoading: false,
  error: null,
  teams: [],
  initialized: false,
};

const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getTeamsSuccess(state, action) {
      state.teams = action.payload;
      state.isLoading = false;
      state.initialized = true;
    },
    addTeamSuccess(state, action) {
      state.teams = [action.payload, ...state.teams];
      state.isLoading = false;
    },
    updateTeamSuccess(state, action) {
      const idx = state.teams.findIndex((t) => t._id === action.payload._id);
      if (idx !== -1) state.teams[idx] = action.payload;
      state.isLoading = false;
    },
    removeTeamSuccess(state, action) {
      state.teams = state.teams.filter((t) => t._id !== action.payload);
      state.isLoading = false;
    },
  },
});

export const {
  getTeamsSuccess,
  addTeamSuccess,
  updateTeamSuccess,
  removeTeamSuccess,
} = teamsSlice.actions;

export default teamsSlice.reducer;

export const getAllTeams = (state) => state.teams;

export function fetchTeams(partnerId) {
  return async (dispatch) => {
    dispatch(teamsSlice.actions.startLoading());
    try {
      const teams = await getTeams(partnerId);
      dispatch(teamsSlice.actions.getTeamsSuccess(teams || []));
    } catch (error) {
      dispatch(teamsSlice.actions.hasError(error?.message || error));
    }
  };
}

export function createTeam(partnerId, data) {
  return async (dispatch) => {
    dispatch(teamsSlice.actions.startLoading());
    try {
      const team = await createTeamApi(partnerId, data);
      dispatch(teamsSlice.actions.addTeamSuccess(team));
      return Promise.resolve(team);
    } catch (error) {
      dispatch(teamsSlice.actions.hasError(error?.message || error));
      return Promise.reject(error);
    }
  };
}

export function updateTeam(partnerId, teamId, data) {
  return async (dispatch) => {
    dispatch(teamsSlice.actions.startLoading());
    try {
      const team = await updateTeamApi(partnerId, teamId, data);
      dispatch(teamsSlice.actions.updateTeamSuccess(team));
      return team;
    } catch (error) {
      dispatch(teamsSlice.actions.hasError(error?.message || error));
      throw error;
    }
  };
}

export function removeTeam(partnerId, teamId) {
  return async (dispatch) => {
    dispatch(teamsSlice.actions.startLoading());
    try {
      await deleteTeamApi(partnerId, teamId);
      dispatch(teamsSlice.actions.removeTeamSuccess(teamId));
    } catch (error) {
      dispatch(teamsSlice.actions.hasError(error?.message || error));
      throw error;
    }
  };
}
